export type FitzpatrickScaleValue = string | null

export interface FitzpatrickTypeOption {
    key: string
    label: string
    swatch: string
    description: string
    tooltip: string
}

export const FITZPATRICK_TYPE_OPTIONS: FitzpatrickTypeOption[] = [
    {
        key: 'I',
        label: 'Tipo I',
        swatch: '#f6ddc9',
        description: 'Sempre queima, nunca bronzeia',
        tooltip: 'Pele muito clara, extremamente sensível ao sol — sempre queima e nunca bronzeia. Alto risco de dano actínico e câncer de pele.',
    },
    {
        key: 'II',
        label: 'Tipo II',
        swatch: '#eec39a',
        description: 'Queima com facilidade, bronzeia minimamente',
        tooltip: 'Pele clara, queima com facilidade e bronzeia muito pouco. Sensibilidade alta ao sol.',
    },
    {
        key: 'III',
        label: 'Tipo III',
        swatch: '#dba97b',
        description: 'Queima moderadamente, bronzeia gradualmente',
        tooltip: 'Pele morena clara, pode queimar moderadamente mas bronzeia de forma gradual e uniforme.',
    },
    {
        key: 'IV',
        label: 'Tipo IV',
        swatch: '#b98058',
        description: 'Queima minimamente, bronzeia bem',
        tooltip: 'Pele morena moderada, raramente queima e bronzeia com facilidade e intensidade.',
    },
    {
        key: 'V',
        label: 'Tipo V',
        swatch: '#8a5a3c',
        description: 'Raramente queima, bronzeia intensamente',
        tooltip: 'Pele morena escura, raramente queima e bronzeia de forma intensa e rápida.',
    },
    {
        key: 'VI',
        label: 'Tipo VI',
        swatch: '#4a2f22',
        description: 'Nunca queima, totalmente pigmentada',
        tooltip: 'Pele negra, nunca queima — a mais protegida naturalmente contra os raios UV.',
    },
]

export function findFitzpatrickType(key: FitzpatrickScaleValue): FitzpatrickTypeOption | null {
    return FITZPATRICK_TYPE_OPTIONS.find((option) => option.key === key) ?? null
}

export function isFitzpatrickScaleValueEmpty(value: FitzpatrickScaleValue | undefined): boolean {
    return !value
}
